import { Injectable } from '@angular/core';
import { I18nService } from './i18n.service';

@Injectable({
  providedIn: 'root'
})
export class FontService {
  constructor(private i18nService: I18nService) {}

  /**
   * 根據當前語系取得對應的字型族系字串
   * 供其他組件使用，例如 ECharts 圖表設定
   */
  getFontFamily(): string {
    const currentLang = this.i18nService.getCurrentLanguage();
    
    switch (currentLang) {
      case 'ja-JP':
        return 'Noto Sans JP, Hiragino Sans, Yu Gothic UI, Roboto, sans-serif';
      case 'zh-TW':
        return 'Noto Sans TC, Microsoft JhengHei UI, PingFang TC, Roboto, sans-serif';
      case 'en-US':
        return 'Roboto, Segoe UI, System UI, Helvetica Neue, Arial, sans-serif';
      case 'th-TH':
        return 'Noto Sans Thai, Sarabun, Tahoma, Roboto, Arial Unicode MS, sans-serif';
      case 'id-ID':
        return 'Roboto, Noto Sans, Open Sans, Segoe UI, Helvetica Neue, Arial, sans-serif';
      default:
        return 'Roboto, Arial, sans-serif';
    }
  }

  /**
   * 特定の言語のフォントファミリーを取得
   */
  getFontFamilyByLang(lang: string): string {
    switch (lang) {
      case 'ja-JP':
        return 'Noto Sans JP, Hiragino Sans, Yu Gothic UI, Roboto, sans-serif';
      case 'zh-TW':
        return 'Noto Sans TC, Microsoft JhengHei UI, PingFang TC, Roboto, sans-serif';
      case 'en-US':
        return 'Roboto, Segoe UI, System UI, Helvetica Neue, Arial, sans-serif';
      case 'th-TH':
        return 'Noto Sans Thai, Sarabun, Tahoma, Roboto, Arial Unicode MS, sans-serif';
      case 'id-ID':
        return 'Roboto, Noto Sans, Open Sans, Segoe UI, Helvetica Neue, Arial, sans-serif';
      default:
        return 'Roboto, Arial, sans-serif';
    }
  }

  /**
   * 等幅フォントファミリーを取得（コード表示用）
   */
  getMonospaceFontFamily(): string {
    return 'Consolas, Monaco, Courier New, monospace';
  }

  /**
   * フォントファミリーの配列を取得（フォールバック用）
   */
  getFontFamilyArray(): string[] {
    const currentLang = this.i18nService.getCurrentLanguage();
    
    switch (currentLang) {
      case 'ja-JP':
        return ['Noto Sans JP', 'Hiragino Sans', 'Yu Gothic UI', 'Roboto', 'sans-serif'];
      case 'zh-TW':
        return ['Noto Sans TC', 'Microsoft JhengHei UI', 'PingFang TC', 'Roboto', 'sans-serif'];
      case 'en-US':
        return ['Roboto', 'Segoe UI', 'System UI', 'Helvetica Neue', 'Arial', 'sans-serif'];
      case 'th-TH':
        return ['Noto Sans Thai', 'Sarabun', 'Tahoma', 'Roboto', 'Arial Unicode MS', 'sans-serif'];
      case 'id-ID':
        return ['Roboto', 'Noto Sans', 'Open Sans', 'Segoe UI', 'Helvetica Neue', 'Arial', 'sans-serif'];
      default:
        return ['Roboto', 'Arial', 'sans-serif'];
    }
  }
}
